import { HeaderIcon, SearchIcon, SidebarIcon, KebabIcon } from "./icons";

export function ChatHeader({ botName }: { botName: string }) {
  return (
    <div className="flex items-center gap-[11px] px-3.5 py-2.5 bg-tg-window border-b border-tg-border shrink-0">
      <div className="flex items-center justify-center size-9 rounded-full shrink-0 font-display italic font-extrabold text-base text-bg bg-[linear-gradient(135deg,var(--color-accent)_0%,#C9620F_100%)]">
        S
      </div>
      <div className="flex flex-col flex-1 min-w-0">
        <div className="text-[15px] font-semibold leading-tight tracking-[-0.005em] text-white">
          {botName}
        </div>
        <div className="text-[13px] leading-tight text-tg-text-muted mt-0.5">
          bot · online
        </div>
      </div>
      <div className="flex items-center gap-1 text-tg-icon">
        <HeaderIcon>{SearchIcon}</HeaderIcon>
        <HeaderIcon>{SidebarIcon}</HeaderIcon>
        <HeaderIcon>{KebabIcon}</HeaderIcon>
      </div>
    </div>
  );
}
